import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const defaultSkinnerBoxKey = "skinner-box-0-false";

export interface SkinnerBoxSliceState {
  shouldShowSkinnerBox: boolean;
  skinnerBoxClaimableAmount: number;
  skinnerBoxKey: string;
  showSkinnerBoxFromWS: boolean;
  wsClaimableAmount: number;
}

const initialState: SkinnerBoxSliceState = {
  shouldShowSkinnerBox: false,
  skinnerBoxClaimableAmount: 0,
  skinnerBoxKey: defaultSkinnerBoxKey,
  showSkinnerBoxFromWS: false,
  wsClaimableAmount: 0,
};

const skinnerBoxSlice = createSlice({
  name: "@skinnerBox",
  initialState,
  reducers: {
    updateSkinnerBoxFromWS(state, action: PayloadAction<{ amount: number; shouldShow: boolean }>) {
      const amountNumber = action.payload.amount;
      const shouldShow = action.payload.shouldShow;
      state.wsClaimableAmount = amountNumber;
      state.showSkinnerBoxFromWS = shouldShow;
      state.skinnerBoxKey = `skinner-box-${amountNumber}-${shouldShow}`;
    },
    updateSkinnerBoxFromAPI(
      state,
      action: PayloadAction<{ shouldShow: boolean; claimableAmount: number; forceRerender?: boolean }>,
    ) {
      const amountNumber = action.payload.claimableAmount;
      const shouldShow = action.payload.shouldShow;
      state.shouldShowSkinnerBox = action.payload.shouldShow;
      state.skinnerBoxClaimableAmount = action.payload.claimableAmount;
      if (action.payload.forceRerender || action.payload.shouldShow || action.payload.claimableAmount > 0) {
        state.skinnerBoxKey = `skinner-box-${amountNumber}-${shouldShow}`;
      }
    },
    resetSkinnerBoxData(state) {
      // Reset WebSocket data
      state.showSkinnerBoxFromWS = false;
      state.wsClaimableAmount = 0;
      // Reset API data to clear cached values after claim
      state.shouldShowSkinnerBox = false;
      state.skinnerBoxClaimableAmount = 0;
      state.skinnerBoxKey = defaultSkinnerBoxKey;
    },
    reset() {
      return initialState;
    },
  },
});

export const { updateSkinnerBoxFromWS, updateSkinnerBoxFromAPI, resetSkinnerBoxData, reset } = skinnerBoxSlice.actions;

export default skinnerBoxSlice;
